import type {TranslationKey} from "@tolgee/react";
import {EffectiveLineState, LineAiState, LineClassification} from "platformed-client/types";

type StateInfo = {label: TranslationKey; short: TranslationKey; symbol: string};

export const LINE_STATE_INFO = {
  exact: {label: "c.Exact_match", short: "c.Exact", symbol: "✓"},
  partial: {label: "c.Partial_paraphrase[slash]", short: "c.Partial", symbol: "◐"},
  deficient: {label: "c.Present_but_deficient", short: "c.Deficient", symbol: "▲"},
  not_found: {label: "c.Not_found", short: "c.Not_found", symbol: "✗"},
  conflict: {label: "c.Conflict", short: "c.Conflict", symbol: "⚑"},
  judgement: {label: "c.Needs_your_judgement", short: "c.Judgement", symbol: "?"},
  not_applicable: {label: "c.Not_applicable", short: "c.N/A", symbol: "Ø"},
  unassessed: {label: "c.Not_assessed", short: "c.Not_assessed", symbol: "…"},
  scope_pending: {label: "c.Scope_pending", short: "c.Pending", symbol: "⧗"},
  out_of_scope: {label: "c.Out_of_scope", short: "c.Out_of_scope", symbol: "–"},
} as const satisfies Record<EffectiveLineState, StateInfo>;

export type StateTier = "ok" | "attention" | "blocked" | "na";

export const stateTier = (state: EffectiveLineState): StateTier => {
  switch (state) {
    case "exact":
      return "ok";
    case "partial":
    case "deficient":
    case "not_found":
    case "judgement":
      return "attention";
    case "conflict":
      return "blocked";
    default:
      return "na";
  }
};

const TIER_PALETTE: Record<StateTier, string> = {ok: "green", attention: "orange", blocked: "red", na: "gray"};

export const statePalette = (state: EffectiveLineState): string => TIER_PALETTE[stateTier(state)];

/** The classify menu lists these in review order. */
export const CLASSIFY_ORDER: LineClassification[] = [
  "exact",
  "partial",
  "deficient",
  "not_found",
  "conflict",
  "judgement",
  "not_applicable",
];

export const aiClassification = (state: LineAiState): LineClassification =>
  state === "ai_not_applicable" ? "not_applicable" : state;
